export default "__VITE_ASSET__B1VsVqU6__"